import { type ReactNode, useState } from "react";

import { PanelStackContext } from "@lib/logic";

import { PanelStackPage } from "./components/PanelStackPage";

type PanelStackCompound = typeof PanelStackRoot & {
  Page: typeof PanelStackPage;
};

type PanelStackState = { pageIds: string[]; lastMove: "push" | "pop" };

const PanelStackRoot = ({ initial, children }: { initial: string; children: ReactNode }) => {
  const [{ pageIds, lastMove }, setState] = useState<PanelStackState>({ pageIds: [initial], lastMove: "push" });

  const push = (pageId: string) => {
    setState(state => ({ pageIds: [...state.pageIds, pageId], lastMove: "push" }));
  };

  const pop = () => {
    setState(state => (state.pageIds.length > 1 ? { pageIds: state.pageIds.slice(0, -1), lastMove: "pop" } : state));
  };

  return (
    <PanelStackContext.Provider value={{ currentPageId: pageIds.at(-1) ?? initial, lastMove, push, pop }}>
      <div className="grid min-h-0 flex-1 overflow-hidden">{children}</div>
    </PanelStackContext.Provider>
  );
};

/** Pages inside a panel that slide over each other: `push` opens one on top, `pop` goes back to the one below. */
export const PanelStack: PanelStackCompound = Object.assign(PanelStackRoot, {
  Page: PanelStackPage,
});
